import React, { useRef, useState } from "react";
import Shead from "./Shead";
import Snote from "./Snote";
import Ssubject from "./Ssubject";
import Smoyenne from "./Smoyenne";
const CarnetSTable = ({
  unit,
  changeModuleRemarque,
  changeNote,
  unitInedx,
  changeNoteEdge,
}) => {
  const [focusedRow, setFocusedRow] = useState(null);
  const noteRefs = useRef([]);

  return (
    <div className="card ">
      <div className="card-body" style={{ padding: 10 }}>
        <header
          style={{
            background: "#0040ff",
            fontSize: 25,
            fontWeight: "bold",
            textAlign: "center",
            borderRadius: 5,
            color: "white",
            height: 40,
            marginBottom: 2,
          }}
        >
          {unit.unitName}
        </header>

        <table className="table notes-table" style={{ backgroundColor: "#0040ff" }}>
          <thead>
            <tr>
              <Shead
                title="Matiéres"
                color="#ffffff"
                bgColor="#0040ff"
                width="40%"
              />
              <Shead
                title="Note élève"
                color="#1e40af"
                bgColor="#eff6ff"
                Radius="40"
                width="20%"
              />
              <Shead
                title="Min classe"
                color="#1e40af"
                bgColor="#eff6ff"
                width="20%"
              />
              <Shead
                title="Max classe"
                color="#1e40af"
                bgColor="#eff6ff"
                width="20%"
              />
            </tr>
          </thead>
          <tbody>
            <tr>
              <td
                style={{
                  backgroundColor: "#ffffff",
                  borderTop: "2px solid #ffffff",
                }}
                colSpan="4"
              />
            </tr>

            {unit.subjects.map((subject, index) => (
              <tr
                key={index}
                className={focusedRow === index ? "row-focused" : undefined}
                onFocus={() => setFocusedRow(index)}
              >
                <Ssubject
                  text={subject.name}
                  onClick={() => {
                    setFocusedRow(index);
                    if (noteRefs.current[index]) noteRefs.current[index].focus();
                  }}
                />
                <Snote
                  note={subject.note}
                  changeNote={changeNote}
                  subjectIndex={index}
                  unitInedx={unitInedx}
                  min={subject.min}
                  max={subject.max}
                  changeNoteEdge={changeNoteEdge}
                  noteRef={(el) => { noteRefs.current[index] = el; }}
                />
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <Smoyenne
        unitInedx={unitInedx}
        unitName={unit.unitName}
        changeModuleRemarque={changeModuleRemarque}
        color="#ffaa00"
        moyenne={unit.unitMoyenne}
        fontSizeTitle="20px"
        title="Moyenne du Module"
        fontSizeMoyenne="25px"
        remarque={unit.unitRemarque}
      />
    </div>
  );
};

export default CarnetSTable;
